import React, { useEffect } from "react";
import { useRoutes, RouteObject, useLocation, Navigate } from "react-router-dom";
import { Route, routes } from "./routes";
import { AnimatePresence, motion } from "framer-motion";

// Slide transition settings
export const pageVariants = {
    initial: { opacity: 0, x: 100 },
    animate: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.1, ease: "easeInOut" }
    },
    exit: {
        opacity: 0,
        x: -100,  // Exit to left
        transition: { duration: 0.1, ease: "easeInOut" }
    }
};

// Utility to map routes and inject animations
const mapRoutes = (routes: Route[]): RouteObject[] => {
    return routes.map(route => {
        const { element, children, props, redirect, ...rest } = route;

        return {
            ...rest,
            element: redirect ? <Navigate to={redirect} /> : <motion.div
                key={route.path}
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                style={{ width: "100%" }}
            >{React.createElement(element, props || {})}</motion.div>,
            children: children ? mapRoutes(children) : undefined,
        };
    });
};

const AppRoutes = () => {

    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const routeObjects = mapRoutes(routes);

    return (
        <AnimatePresence mode="wait">
            {useRoutes(routeObjects)}
        </AnimatePresence>
    );
};

export default AppRoutes;